import React from "react";
import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";
import Gallery from "../components/Gallery";
import YouTubeEmbed from "../components/YouTubeEmbed";
import CtaBand from "../components/CtaBand";
import useSeo from "../hooks/useSeo";
import useReveal from "../hooks/useReveal";
import { tubPage, seo, business } from "../data/siteData";

export default function TubRefinishing() {
  useSeo(seo["/tub-refinishing"].title, seo["/tub-refinishing"].description);
  useReveal();
  return (
    <>
      <PageHero image={tubPage.hero} title={tubPage.h1} />

      <section className="bg-white py-16">
        <div className="mr-container">
          {tubPage.sections.map((s, i) => (
            <div key={s.subhead} className={`mr-body reveal ${i ? "mt-12" : ""}`}>
              <h2 className="mr-h2 text-2xl sm:text-[28px]">{s.subhead}</h2>
              <div className="mt-4">
                {s.paragraphs.map((p) => (
                  <p key={p.slice(0, 30)} className="text-[16.5px]">
                    {p}
                  </p>
                ))}
              </div>
            </div>
          ))}

          <div className="reveal mt-10 flex flex-wrap gap-3">
            <Link
              to="/contact-us"
              className="bg-[#244aa2] px-8 py-3.5 text-[12px] font-bold uppercase tracking-[0.1em] text-white transition-colors duration-200 hover:bg-[#0c2a66]"
            >
              Contact Us
            </Link>
            <a
              href={`tel:${business.phoneRaw}`}
              className="border-2 border-[#244aa2] px-8 py-3.5 text-[12px] font-bold uppercase tracking-[0.1em] text-[#244aa2] transition-colors duration-200 hover:bg-[#244aa2] hover:text-white"
            >
              Call {business.phone}
            </a>
          </div>

          <div className="reveal mx-auto mt-14 max-w-3xl">
            <YouTubeEmbed id={tubPage.video.id} title={tubPage.video.title} />
          </div>
        </div>
      </section>

      <Gallery images={tubPage.gallery} title="Bathtub Refinishing — Before &amp; After" />
      <CtaBand headline="Make your tub look brand new again" />
    </>
  );
}
